export const floorPlanTemplates = [
  {
    id: 'barndo-1',
    name: 'Classic Barndominium',
    style: 'barndominium',
    baseSqft: 2000,
    beds: 3,
    baths: 2,
    description: 'Open concept living with shop space. Metal building exterior.',
    totalWidth: 60,
    totalHeight: 40,
    rooms: [
      { name: 'Shop/Garage', width: 24, height: 40, x: 0, y: 0 },
      { name: 'Living Room', width: 20, height: 18, x: 24, y: 0 },
      { name: 'Kitchen', width: 16, height: 18, x: 44, y: 0 },
      { name: 'Dining', width: 12, height: 12, x: 24, y: 18 },
      { name: 'Master Bedroom', width: 16, height: 14, x: 44, y: 18 },
      { name: 'Master Bath', width: 10, height: 8, x: 50, y: 32 },
      { name: 'Master Closet', width: 6, height: 8, x: 44, y: 32 },
      { name: 'Bedroom 2', width: 12, height: 12, x: 24, y: 28 },
      { name: 'Bedroom 3', width: 12, height: 10, x: 36, y: 30 },
      { name: 'Bathroom', width: 8, height: 8, x: 36, y: 20 },
      { name: 'Utility', width: 8, height: 8, x: 44, y: 20 },
    ]
  },
  {
    id: 'barndo-2',
    name: 'Large Barndominium',
    style: 'barndominium',
    baseSqft: 2800,
    beds: 4,
    baths: 3,
    description: 'Spacious layout with oversized shop and wraparound porch.',
    totalWidth: 80,
    totalHeight: 50,
    rooms: [
      { name: 'Shop', width: 30, height: 50, x: 0, y: 0 },
      { name: 'Great Room', width: 26, height: 22, x: 30, y: 0 },
      { name: 'Kitchen', width: 18, height: 16, x: 56, y: 0 },
      { name: 'Pantry', width: 6, height: 6, x: 74, y: 0 },
      { name: 'Dining', width: 14, height: 12, x: 56, y: 16 },
      { name: 'Master Suite', width: 18, height: 16, x: 30, y: 22 },
      { name: 'Master Bath', width: 12, height: 10, x: 30, y: 38 },
      { name: 'Master Closet', width: 8, height: 12, x: 42, y: 38 },
      { name: 'Bedroom 2', width: 14, height: 12, x: 48, y: 28 },
      { name: 'Bedroom 3', width: 14, height: 12, x: 62, y: 28 },
      { name: 'Bedroom 4', width: 12, height: 10, x: 68, y: 40 },
      { name: 'Bath 2', width: 8, height: 8, x: 50, y: 40 },
      { name: 'Bath 3', width: 8, height: 8, x: 58, y: 40 },
      { name: 'Laundry', width: 8, height: 6, x: 74, y: 6 },
      { name: 'Office', width: 12, height: 10, x: 70, y: 16 },
    ]
  },
  {
    id: 'ranch-1',
    name: 'Traditional Ranch',
    style: 'ranch',
    baseSqft: 1600,
    beds: 3,
    baths: 2,
    description: 'Single-story classic with attached garage.',
    totalWidth: 56,
    totalHeight: 32,
    rooms: [
      { name: 'Garage', width: 20, height: 20, x: 0, y: 0 },
      { name: 'Living Room', width: 18, height: 16, x: 20, y: 0 },
      { name: 'Kitchen', width: 14, height: 12, x: 38, y: 0 },
      { name: 'Dining', width: 12, height: 12, x: 38, y: 12 },
      { name: 'Entry', width: 6, height: 8, x: 20, y: 16 },
      { name: 'Hall', width: 12, height: 8, x: 26, y: 16 },
      { name: 'Master Bedroom', width: 14, height: 14, x: 0, y: 18 },
      { name: 'Master Bath', width: 8, height: 8, x: 14, y: 18 },
      { name: 'Closet', width: 6, height: 6, x: 14, y: 26 },
      { name: 'Bedroom 2', width: 12, height: 11, x: 20, y: 24 },
      { name: 'Bedroom 3', width: 12, height: 11, x: 32, y: 24 },
      { name: 'Bathroom', width: 8, height: 8, x: 44, y: 24 },
      { name: 'Laundry', width: 4, height: 8, x: 52, y: 12 },
    ]
  },
  {
    id: 'ranch-2',
    name: 'Open Concept Ranch',
    style: 'ranch',
    baseSqft: 1800,
    beds: 3,
    baths: 2,
    description: 'Modern ranch with open kitchen/living and split bedrooms.',
    totalWidth: 60,
    totalHeight: 36,
    rooms: [
      { name: 'Garage', width: 22, height: 22, x: 0, y: 0 },
      { name: 'Great Room', width: 22, height: 20, x: 22, y: 0 },
      { name: 'Kitchen', width: 16, height: 14, x: 44, y: 0 },
      { name: 'Pantry', width: 4, height: 6, x: 56, y: 14 },
      { name: 'Dining', width: 12, height: 12, x: 44, y: 14 },
      { name: 'Entry', width: 8, height: 8, x: 22, y: 20 },
      { name: 'Master Bedroom', width: 16, height: 14, x: 44, y: 26 },
      { name: 'Master Bath', width: 10, height: 8, x: 50, y: 36 },
      { name: 'M. Closet', width: 6, height: 8, x: 44, y: 36 },
      { name: 'Bedroom 2', width: 12, height: 12, x: 0, y: 22 },
      { name: 'Bedroom 3', width: 12, height: 12, x: 12, y: 22 },
      { name: 'Bath 2', width: 8, height: 8, x: 24, y: 28 },
      { name: 'Laundry', width: 6, height: 6, x: 32, y: 28 },
      { name: 'Hall', width: 10, height: 8, x: 30, y: 20 },
    ]
  },
  {
    id: 'modern-1',
    name: 'Modern Minimalist',
    style: 'modern',
    baseSqft: 2200,
    beds: 3,
    baths: 2.5,
    description: 'Clean lines, open spaces, walls of windows.',
    totalWidth: 55,
    totalHeight: 45,
    rooms: [
      { name: 'Great Room', width: 28, height: 24, x: 0, y: 0 },
      { name: 'Kitchen', width: 18, height: 14, x: 28, y: 0 },
      { name: 'Pantry', width: 6, height: 8, x: 46, y: 0 },
      { name: 'Dining', width: 14, height: 12, x: 28, y: 14 },
      { name: 'Powder', width: 6, height: 6, x: 42, y: 14 },
      { name: 'Garage', width: 22, height: 22, x: 0, y: 24 },
      { name: 'Mudroom', width: 8, height: 8, x: 22, y: 24 },
      { name: 'Master Suite', width: 18, height: 16, x: 30, y: 26 },
      { name: 'Master Bath', width: 12, height: 10, x: 30, y: 42 },
      { name: 'M. Closet', width: 8, height: 10, x: 42, y: 42 },
      { name: 'Bedroom 2', width: 14, height: 12, x: 22, y: 32 },
      { name: 'Bedroom 3', width: 12, height: 12, x: 48, y: 26 },
      { name: 'Bath 2', width: 8, height: 8, x: 48, y: 38 },
      { name: 'Office', width: 9, height: 8, x: 46, y: 8 },
    ]
  },
  {
    id: 'farmhouse-1',
    name: 'Classic Farmhouse',
    style: 'farmhouse',
    baseSqft: 2400,
    beds: 4,
    baths: 2.5,
    description: 'Wraparound porch feel, mudroom entry, large kitchen.',
    totalWidth: 65,
    totalHeight: 42,
    rooms: [
      { name: 'Front Porch', width: 40, height: 8, x: 0, y: 0 },
      { name: 'Living Room', width: 18, height: 16, x: 0, y: 8 },
      { name: 'Dining Room', width: 14, height: 14, x: 18, y: 8 },
      { name: 'Kitchen', width: 18, height: 16, x: 32, y: 8 },
      { name: 'Pantry', width: 6, height: 8, x: 50, y: 8 },
      { name: 'Mudroom', width: 9, height: 8, x: 56, y: 8 },
      { name: 'Garage', width: 24, height: 24, x: 41, y: 18 },
      { name: 'Laundry', width: 8, height: 8, x: 50, y: 16 },
      { name: 'Powder', width: 6, height: 6, x: 32, y: 24 },
      { name: 'Master Bed', width: 16, height: 14, x: 0, y: 24 },
      { name: 'Master Bath', width: 10, height: 8, x: 0, y: 38 },
      { name: 'M. Closet', width: 6, height: 8, x: 10, y: 38 },
      { name: 'Bedroom 2', width: 12, height: 12, x: 16, y: 24 },
      { name: 'Bedroom 3', width: 12, height: 12, x: 16, y: 36 },
      { name: 'Bedroom 4', width: 12, height: 10, x: 28, y: 30 },
      { name: 'Bath 2', width: 8, height: 8, x: 28, y: 40 },
      { name: 'Hall', width: 4, height: 16, x: 28, y: 24 },
    ]
  },
  {
    id: 'cottage-1',
    name: 'Cozy Cottage',
    style: 'cottage',
    baseSqft: 1200,
    beds: 2,
    baths: 1,
    description: 'Efficient small home, perfect for starters or downsizing.',
    totalWidth: 40,
    totalHeight: 32,
    rooms: [
      { name: 'Porch', width: 12, height: 6, x: 14, y: 0 },
      { name: 'Living Room', width: 16, height: 14, x: 0, y: 6 },
      { name: 'Kitchen', width: 12, height: 12, x: 16, y: 6 },
      { name: 'Dining Nook', width: 10, height: 8, x: 28, y: 6 },
      { name: 'Pantry', width: 4, height: 6, x: 28, y: 14 },
      { name: 'Master Bed', width: 14, height: 12, x: 0, y: 20 },
      { name: 'Closet', width: 6, height: 6, x: 14, y: 20 },
      { name: 'Bathroom', width: 8, height: 8, x: 14, y: 26 },
      { name: 'Bedroom 2', width: 12, height: 12, x: 22, y: 20 },
      { name: 'Laundry', width: 6, height: 6, x: 34, y: 20 },
      { name: 'Hall', width: 8, height: 6, x: 22, y: 14 },
    ]
  }
];

export const templateStyles = ['barndominium', 'ranch', 'modern', 'farmhouse', 'cottage'];
